export function getColor(id) {
  const colors = [
    '#224086', // krunica svete gertrude
    '#944510', // krunica svete rite
    '#1b921b', // gospina krunica
    'cyan',
    'lime',
    'magenta',
    'pink',
    'red',
  ];
  return colors[id];
}
